var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranchingScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 175C58.9775 175 25.4001 141.423 25.4001 100C25.4001 58.5774 58.9775 25 100.4 25C141.823 25 175.4 58.5774 175.4 100C175.4 141.423 141.823 175 100.4 175Z",
    fill: "url(#paint0_linear_26801_3344)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.097 81.5957C132.097 79.0533 130.04 76.9961 127.498 76.9961H70.5461L84.3449 49.3984H127.498C130.04 49.3984 132.097 47.3412 132.097 44.7988C132.097 42.2565 130.04 40.1992 127.498 40.1992H81.5017C79.7588 40.1992 78.1688 41.1829 77.3872 42.7416L58.9888 79.5385C58.657 80.202 58.5475 80.9012 58.549 81.5957H44.3982C34.2511 81.5957 25.9998 89.8471 25.9998 99.9941C25.9998 110.141 34.2511 118.393 44.3982 118.393H58.549C58.5472 119.087 58.657 119.786 58.9888 120.45L77.3872 157.247C78.1688 158.805 79.7588 159.789 81.5017 159.789H127.498C130.04 159.789 132.097 157.732 132.097 155.189C132.097 152.647 130.04 150.59 127.498 150.59H84.3449L70.5461 122.992H127.498C130.04 122.992 132.097 120.935 132.097 118.393C132.097 115.85 130.04 113.793 127.498 113.793H93.5438C97.4059 110.418 99.9001 105.516 99.9001 99.9941C99.9001 94.4725 97.4059 89.5699 93.5438 86.1953H127.498C130.04 86.1953 132.097 84.1381 132.097 81.5957Z",
    fill: "url(#paint1_linear_26801_3344)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.697 58.5977H168.601C176.21 58.5977 182.4 52.4078 182.4 44.7988C182.4 37.1898 176.21 31 168.601 31H140.697C133.088 31 126.898 37.1898 126.898 44.7988C126.898 52.4078 133.088 58.5977 140.697 58.5977ZM168.601 67.7969H140.697C133.088 67.7969 126.898 73.9867 126.898 81.5957C126.898 89.2047 133.088 95.3945 140.697 95.3945H168.601C176.21 95.3945 182.4 89.2047 182.4 81.5957C182.4 73.9867 176.21 67.7969 168.601 67.7969ZM168.601 141.391H140.697C133.088 141.391 126.898 147.58 126.898 155.189C126.898 162.798 133.088 168.988 140.697 168.988H168.601C176.21 168.988 182.4 162.798 182.4 155.189C182.4 147.58 176.21 141.391 168.601 141.391ZM168.601 104.594H140.697C133.088 104.594 126.898 110.784 126.898 118.393C126.898 126.002 133.088 132.191 140.697 132.191H168.601C176.21 132.191 182.4 126.002 182.4 118.393C182.4 110.784 176.21 104.594 168.601 104.594Z",
    fill: "url(#paint2_linear_26801_3344)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5017 76.9961H40.3982C27.7177 76.9961 17.4001 87.3136 17.4001 99.9941C17.4001 112.675 27.7177 122.992 40.3982 122.992H77.5017C90.1822 122.992 100.5 112.675 100.5 99.9941C100.5 87.3136 90.1822 76.9961 77.5017 76.9961ZM68.3025 104.594H49.9041C47.3617 104.594 45.3044 102.536 45.3044 99.9941C45.3044 97.4518 47.3617 95.3945 49.9041 95.3945H68.3025C70.8448 95.3945 72.9021 97.4518 72.9021 99.9941C72.9021 102.536 70.8448 104.594 68.3025 104.594Z",
    fill: "url(#paint3_linear_26801_3344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_3344",
    x1: 25.4001,
    y1: 36.7188,
    x2: 168.369,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_3344",
    x1: 64.4001,
    y1: 100.332,
    x2: 127.354,
    y2: 118.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_3344",
    x1: 154.4,
    y1: 31.332,
    x2: 154.4,
    y2: 257.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_3344",
    x1: 58.95,
    y1: 76.9961,
    x2: 58.95,
    y2: 122.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchingScenario);
export default __webpack_public_path__ + "static/media/Branching-Scenario.4decc8312c951efe1d774a96052a770d.svg";
export { ForwardRef as ReactComponent };